export const articleTypes = {
  article: 'article',
  infographic: 'infographic',
  notes: 'notes',
  news: 'news',
  publishing: 'publishing',
  video: 'video'
};

export const contentTypeChoices = [
  { id: articleTypes.article, name: 'resources.articles.types.article' },
  { id: articleTypes.infographic, name: 'resources.articles.types.infographic' },
  { id: articleTypes.publishing, name: 'resources.articles.types.publishing' },
  { id: articleTypes.video, name: 'resources.articles.types.video' }
];

export const textArticleTypes = [articleTypes.article, articleTypes.publishing];

export const publicationStatusChoices = [
  { id: 'unpublished', name: 'common.unpublished' },
  { id: 'published', name: 'common.published' }
];

export const sectionChoices = [
  { id: 'event', name: 'common.sections.event' },
  { id: 'project', name: 'common.sections.project' },
  { id: 'all', name: 'common.sections.all' },
  { id: 'article', name: 'common.sections.article' }
];

export const topicChoices = [
  { id: 'bim', name: 'common.topics.bim' },
  { id: 'blockchain', name: 'common.topics.blockchain' },
  { id: 'artificialintelligence', name: 'common.topics.artificialintelligence' },
  { id: 'iot', name: 'common.topics.iot' },
  { id: 'bigdata', name: 'common.topics.bigdata' }
];

export const infraestructureTypeChoices = [
  { id: 'energy', name: 'common.contentTypes.energy' },
  { id: 'transport', name: 'common.contentTypes.transport' },
  { id: 'boundary', name: 'common.contentTypes.boundary' },
  { id: 'telecommunications', name: 'common.contentTypes.telecommunications' }
];

export const areaTypeChoices = [
  { id: 'NACIONAL', name: 'common.areaTypes.nacional' },
  { id: 'BINACIONAL', name: 'common.areaTypes.binacional' }
];

export const bankChoices = [
  { id: 'bid', name: 'BID' },
  { id: 'caf', name: 'CAF' },
  { id: 'fonplata', name: 'FONPLATA' },
  { id: 'bid-caf', name: 'BID-CAF' },
  { id: 'bid-fonplata', name: 'BID-FONPLATA' },
  { id: 'caf-fonplata', name: 'CAF-FONPLATA' },
  { id: 'bid-caf-fonplata', name: 'BID-CAF-FONPLATA' }
];

export const eventTypeChoices = [
  { id: 'workshop', name: 'resources.events.types.workshop' },
  { id: 'meeting', name: 'resources.events.types.meeting' },
  { id: 'conference', name: 'resources.events.types.conference' },
  { id: 'training', name: 'resources.events.types.training' },
  { id: 'seminar', name: 'resources.events.types.seminar' }
];

export const countryChoices = [
  { id: 'Argentina', name: 'Argentina' },
  { id: 'Bahamas', name: 'Bahamas' },
  { id: 'Barbados', name: 'Barbados' },
  { id: 'Belice', name: 'Belice' },
  { id: 'Bolivia', name: 'Bolivia' },
  { id: 'Brasil', name: 'Brasil' },
  { id: 'Chile', name: 'Chile' },
  { id: 'Colombia', name: 'Colombia' },
  { id: 'Costa Rica', name: 'Costa Rica' },
  { id: 'Ecuador', name: 'Ecuador' },
  { id: 'El Salvador', name: 'El Salvador' },
  { id: 'Guatemala', name: 'Guatemala' },
  { id: 'Guyana', name: 'Guyana' },
  { id: 'Haití', name: 'Haití' },
  { id: 'Honduras', name: 'Honduras' },
  { id: 'Jamaica', name: 'Jamaica' },
  { id: 'México', name: 'México' },
  { id: 'Nicaragua', name: 'Nicaragua' },
  { id: 'Panamá', name: 'Panamá' },
  { id: 'Paraguay', name: 'Paraguay' },
  { id: 'Perú', name: 'Perú' },
  { id: 'República Dominicana', name: 'República Dominicana' },
  { id: 'Suriname', name: 'Suriname' },
  { id: 'Trinidad y Tobago', name: 'Trinidad y Tobago' },
  { id: 'Uruguay', name: 'Uruguay' },
  { id: 'Venezuela', name: 'Venezuela' },
  { id: 'África', name: 'África' },
  { id: 'América del Norte', name: 'América del Norte' },
  { id: 'Antártida', name: 'Antártida' },
  { id: 'Asia', name: 'Asia' },
  { id: 'Europa', name: 'Europa' },
  { id: 'Oceanía', name: 'Oceanía' },
  { id: 'On Line', name: 'On Line' }
];

export const statusChoices = [
  { id: 'profiling', name: 'Perfil' },
  { id: 'pre_execution', name: 'Pre-ejecución' },
  { id: 'execution', name: 'Ejecución' },
  { id: 'finished', name: 'Concluido' }
];

export const financingChoices = [
  { id: 'public_project', name: 'Público' },
  { id: 'private_project', name: 'Privado' },
  { id: 'mixed_project', name: 'Mixto' }
];

export const infraestructureChoices = [
  { id: 'energy', name: 'Energía' },
  { id: 'transport', name: 'Transporte y logística' },
  { id: 'boundary', name: 'Fronteras' },
  { id: 'telecommunications', name: 'Telecomunicaciones' }
];

export const subsectorChoices = [
  { id: 'CARRETERO', name: 'Carretero' },
  { id: 'FLUVIAL', name: 'Fluvial' },
  { id: 'AÉREO', name: 'Aéreo' },
  { id: 'PASOS DE FRONTERA', name: 'Pasos de frontera' },
  { id: 'FERROVIARIO', name: 'Ferroviario' },
  { id: 'INTERCONEXION ENERGÉTICA', name: 'Interconexión energética' },
  { id: 'VIALIDAD', name: 'Vialidad' },
  { id: 'MULTIMODAL', name: 'Multimodal' },
  { id: 'GENERACIÓN ENERGÉTICA', name: 'Generación energética' }
];

export const sortByChoices = [
  { id: 'created_at', name: 'Fecha de creación' },
  { id: 'updated_at', name: 'Fecha de última modificación' },
  { id: 'material_date', name: 'Fecha material' }
];

export const iirsaInfraestructureChoices = [
  { id: 'energy', name: 'Energía' },
  { id: 'transport', name: 'Transporte y logística' },
  { id: 'boundary', name: 'Fronteras' },
  { id: 'telecommunications', name: 'Telecomunicaciones' }
];
